import { render, staticRenderFns } from "./TableItemActions.vue?vue&type=template&id=30f78b0e&scoped=true&"
import script from "./TableItemActions.vue?vue&type=script&lang=js&"
export * from "./TableItemActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f78b0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30f78b0e')) {
      api.createRecord('30f78b0e', component.options)
    } else {
      api.reload('30f78b0e', component.options)
    }
    module.hot.accept("./TableItemActions.vue?vue&type=template&id=30f78b0e&scoped=true&", function () {
      api.rerender('30f78b0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crud/table/TableItemActions.vue"
export default component.exports